import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../hooks/useAppDispatcher.hook';
import { setHeaderTitle } from '../../../redux/App/App.slice';
import { getControlPanelListThunk } from '../../../redux/ControlPanel/ControlPanelList/ControlPanelList.thunk';
import { ControlSectionTypes } from '../../../redux/ControlPanel/ControlPanelList/ControlPanelList.type';
import { getControlPanelList } from '../../../redux/ControlPanel/ControlPanelList/ControlPanelList.slice';

import { StyledControlPanelLayout } from './ControlPanel.styles';
import { StatusesSectionComponent } from './components/StatusesSection.component';
import { RegionsSectionComponent } from './components/RegionsSection.component';
import { HrsSectionComponent } from './components/hrsSection/HrsSection.component';
import { VacanciesSectionComponent } from './components/VacanciesSection.component';
import { SourcesSectionComponent } from './components/SourcesSection.component';
import { TagsSectionComponent } from './components/TagsSection.component';
import { InternshipStatusesSectionComponent } from './components/InternshipStatusesSection.component';
import { SystemSectionComponent } from './components/SystemSection.component';

const ControlPanelPage: React.FC = () => {
  const dispatch = useAppDispatch();

  const controlPanelList = useSelector(getControlPanelList);

  useEffect(() => {
    dispatch(setHeaderTitle('Control panel'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getControlPanelListThunk());
  }, [dispatch]);

  return (
    <StyledControlPanelLayout>
      {controlPanelList.includes(ControlSectionTypes.REGIONS) && <RegionsSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.HRS) && <HrsSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.VACANCIES) && <VacanciesSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.STATUSES) && <StatusesSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.SOURCES) && <SourcesSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.TAGS) && <TagsSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.INTERNSHIP_STATUSES) && <InternshipStatusesSectionComponent />}
      {controlPanelList.includes(ControlSectionTypes.SYSTEM) && <SystemSectionComponent />}
    </StyledControlPanelLayout>
  );
};

export default ControlPanelPage;
